var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23741 7.74888C6.06923 5.20867 9.29121 3.534 10.9033 2.72489C15.5063 0.414697 16.4627 0.0133926 17.0861 0.000141289C17.2232 -0.00277319 17.5298 0.0382296 17.7284 0.232668C17.8961 0.396848 17.9422 0.618632 17.9643 0.774293C17.9864 0.929954 18.0139 1.28455 17.992 1.56163C17.7426 4.7241 16.6633 12.3986 16.1142 15.9406C15.8818 17.4394 15.4244 17.9419 14.9815 17.9911C14.0189 18.098 13.288 17.2235 12.3558 16.4861C10.897 15.3323 10.0729 14.614 8.65691 13.488C7.02048 12.1868 8.08131 11.4716 9.0139 10.3027C9.25797 9.99686 13.4988 5.34226 13.5809 4.92001C13.5912 4.86721 13.6007 4.67036 13.5038 4.56642C13.4069 4.46248 13.2639 4.49802 13.1606 4.52629C13.0143 4.56636 10.6839 6.42501 6.16938 10.1022C5.5079 10.6503 4.90875 10.9174 4.37193 10.9034C3.78013 10.888 2.64175 10.4996 1.79548 10.1677C0.757494 9.76056 -0.0674757 9.5453 0.00436067 8.85385C0.0417775 8.4937 0.452793 8.12538 1.23741 7.74888Z",
    fill: "#3889FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram2);
export default __webpack_public_path__ + "static/media/telegram2.11336cf5.svg";
export { ForwardRef as ReactComponent };